export default {
  YEAR_DESC: 'YEAR_DESC',
  YEAR_ASC: 'YEAR_ASC',
  SINCE_DESC: 'SINCE_DESC',
  SINCE_ASC: 'SINCE_ASC',
  CREATED_AT_DESC: 'CREATED_AT_DESC',
};
